<template>
  <v-row class="pl-1">
    <v-col>
      <v-tabs
        v-model="userTab"
        show-arrows
        class="user-tabs"
        grow
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.title"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        id="user-tabs-content"
        v-model="userTab"
        class="mt-5"
      >
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          ></v-progress-linear>
        </div>

        <v-tab-item>
          <bot-data-config
            :chat-bot-id.sync="chatBotId"
            :plataformas.sync="plataformas"
            @cancelar-bot="resetAllData"
          />
        </v-tab-item>

        <v-tab-item>
          <bot-plataforma-config
            :chat-bot-id.sync="chatBotId"
            :is-messenger-setted="plataformas.Messenger"
            :is-whats-app-setted="plataformas.WhatsApp"
            @cancelar-configs="resetAllData"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { computed, provide, ref, watchEffect } from '@vue/composition-api'
import {
  mdiCogOutline,
} from '@mdi/js'
import { required } from '@/@core/utils/validation'
import BotPlataformaConfig from './tab-bot-config/BotPlataformaConfig.vue'
import BotDataConfig from './tab-bot-config/BotDataConfig.vue'
import ChatBotService from '@/services/modules/ChatBotService'
import ChatBotConfigWhatsAppModel from '@/models/entities/chat-bot/ChatBotConfigWhatsAppModel'
import ChatBotConfigMessengerModel from '@/models/entities/chat-bot/ChatBotConfigMessengerModel'

export default {
  components: { BotDataConfig, BotPlataformaConfig },
  props: {
    chatBotId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const tabs = [
      { icon: mdiCogOutline, title: 'Dados do ChatBot' },
      { icon: mdiCogOutline, title: 'Dados da plataforma' },
    ]
    const userTab = ref(0)
    const loading = ref(false)

    const activeStep = ref(1)

    const plataformas = ref({
      WhatsApp: false,
      Messenger: false,
    })

    const isChatBotNovo = computed(() => !props.chatBotId)

    const blankChatBotData = {
      nome: '',
      descricao: '',
      mensagemInicial: '',
      mensagemEncerramento: '',
      timeoutAlertaChatBotMin: 5,
      timeoutAlertaChatBotMensagem: '',
      timeoutEncerramentoChatBotMin: 8,
      timeoutEncerramentoChatBotMensagem: '',
    }
    const chatBotData = ref(JSON.parse(JSON.stringify(blankChatBotData)))

    async function getChatBot() {
      const resGetChatBot = await ChatBotService.getById(props.chatBotId)
      if (resGetChatBot) chatBotData.value = resGetChatBot
    }
    provide('chatBotData', chatBotData)

    const chatBotWhatsAppData = ref(new ChatBotConfigWhatsAppModel())

    async function getWhatsAppChatBot() {
      const resGetWhatsApp = await ChatBotService.getConfigWhatsApp(props.chatBotId)
      if (resGetWhatsApp) {
        chatBotWhatsAppData.value = resGetWhatsApp
        plataformas.value.WhatsApp = true
      }
    }
    provide('chatBotWhatsAppData', chatBotWhatsAppData)

    const chatBotMessengerData = ref(new ChatBotConfigMessengerModel())
    async function getMessengerChatBot() {
      const resGeMessenger = await ChatBotService.getConfigMessenger(props.chatBotId)
      if (resGeMessenger) {
        chatBotMessengerData.value = resGeMessenger
        plataformas.value.Messenger = true
      }
    }
    provide('chatBotMessengerData', chatBotMessengerData)

    async function resetAllData() {
      await Promise.all([
        getChatBot(),
        getWhatsAppChatBot(),
        getMessengerChatBot(),
      ])
    }

    watchEffect(async () => {
      if (props.chatBotId) {
        await resetAllData()
        emit('update:chat-bot-id', props.chatBotId)
      }
    })

    provide('chatBotPlataformas', plataformas)

    return {
      activeStep,
      chatBotData,
      isChatBotNovo,
      chatBotWhatsAppData,
      getChatBot,
      getWhatsAppChatBot,
      tabs,
      userTab,
      loading,
      plataformas,
      resetAllData,
      validators: {
        required,
      },
    }
  },
}
</script>
